module.exports = __webpack_public_path__ + "img/weserve_ai_chatbot_icon.e55a3050.png";